(function (root, factory) {
  var lib = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = lib;
  root.FBWishlistRewards = lib;
  if (root.document) root.document.addEventListener('DOMContentLoaded', function () {
    root.document.querySelectorAll('[data-wishlist-rewards]').forEach(lib.start);
  });
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';
  var PREFIX = '/wishlist/rewards';
  var TOKEN = /^[a-f0-9]{32}$/;
  var memory = {};
  function saved(key, value) {
    try {
      if (value !== undefined) root.sessionStorage.setItem('fb_wr_' + key, JSON.stringify(value));
      else return JSON.parse(root.sessionStorage.getItem('fb_wr_' + key) || 'null');
    } catch (_) { if (value === undefined) return memory[key] || null; }
    if (value !== undefined) memory[key] = value;
    return value;
  }
  function uuid() { return root.crypto.randomUUID(); }
  function campaign(search) {
    var params = new root.URLSearchParams(search), result = {}, found = false;
    ['source', 'medium', 'campaign', 'content'].forEach(function (key) {
      var value = params.get('utm_' + key);
      if (value) { result[key] = value.replace(/[^a-zA-Z0-9 _.-]/g, '').slice(0, 100); found = true; }
    });
    if (found) saved('campaign', result);
    return found ? result : saved('campaign') || {};
  }
  function invitationUrl(token) { return TOKEN.test(token || '') ? 'https://figandbloom.com/pages/wishlist?invite=' + token : null; }
  function errorText(error) {
    if (error && error.status === 429) return 'Too many attempts. Please wait a few minutes and try again.';
    if (error && error.status === 401) return 'Please verify your mobile again to continue.';
    var message = error && error.payload && error.payload.error && error.payload.error.message;
    return typeof message === 'string' ? message : 'We couldn’t complete that. Please try again.';
  }
  function start(host) {
    if (!host || host._rewardsStarted || !root.FBRemindersAPI) return;
    host._rewardsStarted = true;
    var api = root.FBRemindersAPI.create(host.dataset.apiBase);
    var copyDefaults = {
      rewards_paused: 'New wish list rewards are currently paused. You can still edit your list and access existing gift cards.',
      view_rewards_link: 'View your wish list rewards',
      eligible_share: 'Eligible shares earn a {{reward_amount}} gift card for each of you.',
      offer: 'A little thank you: you can each earn a {{reward_amount}} gift card when they share an eligible wish list.'
    };
    function copy(key, vars) {
      var slots = { rewards_paused: host.dataset.rewardsPaused, view_rewards_link: host.dataset.viewRewardsLink };
      var text = slots[key] || copyDefaults[key] || '';
      return text.replace(/{{\s*(reward_amount)\s*}}/g, function (match, name) {
        return vars && Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : match;
      });
    }
    var rewardVars = { reward_amount: host.dataset.rewardAmount || '' };
    var params = new root.URLSearchParams(root.location.search);
    var recipient = host.dataset.wishlistRewards === 'recipient';
    var token = params.get('invite');
    var scope = recipient || params.get('identity') === 'list' ? 'list' : 'member';
    var attribution = campaign(root.location.search);
    var campaignKey = ['source', 'medium', 'campaign', 'content'].map(function (key) { return attribution[key] || ''; }).join('|');
    var ownerId = null, busy = false;
    var content = node('div'), status = node('p');
    status.className = 'fb-wishlist-rewards__feedback';
    status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
    host.textContent = ''; host.appendChild(content); host.appendChild(status);
    host.className += ' ph-no-capture';
    function node(tag, text) { var n = root.document.createElement(tag); if (text != null) n.textContent = text; return n; }
    function paragraph(text, target) { (target || content).appendChild(node('p', text)); }
    function link(text, href, target) { var a = node('a', text); a.href = href; (target || content).appendChild(a); return a; }
    function placeFeedback(target) {
      if (status.parentElement) status.parentElement.removeChild(status);
      target.appendChild(status);
    }
    function action(text, fn, target) {
      var b = node('button', text); b.type = 'button'; b.className = 'fb-wishlist__button';
      b.addEventListener('click', async function () {
        if (busy) return;
        busy = true; b.disabled = true; status.textContent = '';
        placeFeedback(target || content);
        try { await fn(); } catch (error) { status.textContent = errorText(error); }
        finally { busy = false; b.disabled = false; if (!host.contains(status)) content.appendChild(status); }
      });
      (target || content).appendChild(b); return b;
    }
    function input(label, type, autocomplete, target) {
      var wrap = node('label', label), field = node('input'); field.type = type; field.autocomplete = autocomplete;
      if (type === 'tel') field.inputMode = 'tel';
      wrap.appendChild(field); (target || content).appendChild(wrap); return field;
    }
    function post(path, body) { return api.request(PREFIX + path, { method: 'POST', body: body || {} }); }
    async function eventOnce(event) {
      var key = event + '_' + token;
      if (saved(key)) return;
      await post('/invitations/' + token + '/events', { event: event }); saved(key, true);
    }
    function proof(done) {
      var form = node('div'); content.appendChild(form);
      paragraph(scope === 'member' ? 'Sign in with your mobile to invite someone and see your rewards.' : 'Verify your mobile to recover your list and view its rewards. This does not sign you into Reminders.', form);
      var phone = input('Your mobile number', 'tel', 'tel', form);
      var codeWrap = node('div'); form.appendChild(codeWrap);
      action('Send verification code', async function () {
        var value = phone.value.trim();
        if (!value) { status.textContent = 'Enter your mobile number, including country code.'; phone.focus(); return; }
        if (scope === 'member') await api.requestSmsCode(value); else await post('/phone/request', { phone: value });
        codeWrap.textContent = '';
        var code = input('Verification code', 'text', 'one-time-code', codeWrap); code.inputMode = 'numeric'; code.maxLength = 6;
        action('Verify mobile', async function () {
          var body = { phone: value, code: code.value.trim() };
          if (scope === 'member') { if (ownerId) body.expectedOwnerId = ownerId; await post('/member/verify', body); api.clearMe(); } else await post('/phone/verify', body);
          ownerId = null;
          if (recipient && root.CustomEvent) root.document.dispatchEvent(new root.CustomEvent('fb-wishlist:recovered'));
          await done();
        }, codeWrap);
        status.textContent = 'Code sent. Enter it below.'; code.focus();
      }, form);
    }
    function emailRecovery() {
      content.textContent = '';
      content.appendChild(node('h2', 'Recover your wish list with email'));
      paragraph('Use the email saved with your list. Email recovery restores your list only. Gift cards and reward invitations require mobile verification.');
      var email = input('Your email address', 'email', 'email');
      var codeWrap = node('div'); content.appendChild(codeWrap);
      action('Send email code', async function () {
        var value = email.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) { status.textContent = 'Enter your email address.'; email.focus(); return; }
        await api.request('/wishlist/me/recovery/request', { method: 'POST', body: { email: value } });
        codeWrap.textContent = '';
        var code = input('Email verification code', 'text', 'one-time-code', codeWrap); code.inputMode = 'numeric'; code.maxLength = 6;
        action('Verify email', async function () {
          try {
            await api.request('/wishlist/me/recovery/verify', { method: 'POST', body: { email: value, code: code.value.trim() } });
          } catch (error) {
            status.textContent = error.status === 401 ? 'That email code is invalid or expired. Request a new code and try again.' : errorText(error);
            return;
          }
          if (root.CustomEvent) root.document.dispatchEvent(new root.CustomEvent('fb-wishlist:recovered'));
          content.textContent = ''; paragraph('Your saved list is ready below.');
          paragraph('To view gift cards, verify your mobile on the rewards page.');
          link(copy('view_rewards_link', rewardVars), '/pages/wishlist-rewards?identity=list');
          await sharingManagement();
        }, codeWrap);
        status.textContent = 'If this email has a saved list, a code is on its way. Enter it below.'; code.focus();
      });
      action('Use mobile instead', recipientPanel);
    }
    async function wallet() {
      var response = await api.request(PREFIX + '/wallet?scope=' + scope), data = response.wallet;
      var box = node('section'); box.className = 'fb-wishlist-rewards__wallet'; content.appendChild(box);
      box.appendChild(node('h2', 'Your gift cards'));
      if (!data.cards.length) paragraph('No gift cards yet. Any cards you earn will be kept here, ready for your next gift.', box);
      data.cards.forEach(function (card) {
        var item = node('div'); item.className = 'fb-wishlist-rewards__card'; box.appendChild(item);
        paragraph('$' + card.amount + ' gift card · ' + card.earnedYear, item);
        if (card.ready && typeof card.code === 'string' && card.code) {
          var code = node('code', card.code); item.appendChild(code);
          action('Copy gift card code', async function () {
            if (!root.navigator.clipboard) { status.textContent = 'Select the gift card code above to copy it.'; return; }
            try { await root.navigator.clipboard.writeText(card.code); status.textContent = 'Gift card code copied.'; }
            catch (_) { status.textContent = 'Select the gift card code above to copy it.'; }
          }, item);
        } else paragraph('Being prepared. Check again shortly.', item);
      });
      if (data.cards.length) action('Refresh gift cards', async function () { await post('/wallet/retry', { scope: scope }); await load(); }, box);
    }
    async function choosePerson() {
      var response = await api.request('/people');
      if (!response.ownerId || response.ownerId !== ownerId) throw new Error('Identity changed');
      var box = node('section'); box.className = 'fb-wishlist-rewards__invite'; content.appendChild(box); box.appendChild(node('h2', 'Who would you like to invite?'));
      paragraph('Choose someone you know, or add a new person. We’ll make a link for you to send them.', box);
      var label = node('label', 'Choose a person'), select = node('select'); label.appendChild(select); box.appendChild(label);
      var blank = node('option', 'Choose someone'); blank.value = ''; select.appendChild(blank);
      response.people.forEach(function (person) { var option = node('option', person.name); option.value = person.id; select.appendChild(option); });
      var requestedPerson = params.get('person');
      if (response.people.some(function (person) { return person.id === requestedPerson; })) select.value = requestedPerson;
      var newOption = node('option', 'Add someone new'); newOption.value = '__new'; select.appendChild(newOption);
      var name = input('Their name', 'text', 'off', box);
      var nameField = name.parentElement;
      function updateNameField() {
        var adding = select.value === '__new';
        status.textContent = '';
        nameField.hidden = !adding;
        name.disabled = !adding;
      }
      select.addEventListener('change', updateNameField);
      updateNameField();
      var output = node('div'); output.className = 'fb-wishlist-rewards__invitation';
      var personDraft = null;
      action('Create invitation', async function () {
        var friendId = select.value;
        if (!friendId) { placeFeedback(label); status.textContent = 'Choose someone first.'; select.focus(); return; }
        var expectedOwner = ownerId;
        if (friendId === '__new') {
          if (!name.value.trim()) { placeFeedback(nameField); status.textContent = 'Enter their name.'; name.focus(); return; }
          if (!personDraft || personDraft.name !== name.value.trim()) personDraft = { name: name.value.trim(), key: uuid() };
          var creationKey = personDraft.key;
          var created = await api.request('/people', { method: 'POST', body: { name: name.value.trim(), creationKey: creationKey, confirmNew: true, expectedOwnerId: expectedOwner } });
          friendId = created.person.id;
        }
        var key = 'request_' + campaignKey + '_' + expectedOwner + '_' + friendId;
        var requestId = saved(key) || saved(key, uuid());
        var result = await post('/invitations', { friendId: friendId, expectedOwnerId: expectedOwner, requestId: requestId, campaign: attribution });
        token = result.invitation.token;
        var url = invitationUrl(token); if (!url) throw new Error('Invalid invitation');
        output.textContent = '';
        output.appendChild(node('h3', 'Your invitation is ready to send'));
        paragraph('Copy the link into a message to them. They can choose their favourites and share their list with you.', output);
        var urlField = input('Your invitation link', 'text', 'off', output); urlField.value = url; urlField.readOnly = true;
        action('Copy invitation', async function () {
          try {
            if (!root.navigator.clipboard) throw new Error('Clipboard unavailable');
            await root.navigator.clipboard.writeText(url);
          } catch (_) {
            urlField.focus(); urlField.select();
            status.textContent = 'Select and copy your invitation link above, then send it when you’re ready.';
            return;
          }
          status.textContent = 'Invitation copied. Send it to them when you’re ready.';
          try { await eventOnce('shared'); } catch (_) {}
        }, output);
        if (root.navigator.share) action('Share invitation', async function () {
          try { await root.navigator.share({ title: 'Share your wish list', url: url }); }
          catch (error) { if (error.name === 'AbortError') { status.textContent = 'Sharing cancelled. Your link is ready when you are.'; return; } throw error; }
          status.textContent = 'Invitation shared.';
          try { await eventOnce('shared'); } catch (_) {}
        }, output);
        status.textContent = 'Your invitation is ready.';
      }, box);
      box.appendChild(output);
    }
    async function sharingManagement() {
      var result;
      try { result = await api.request('/wishlist/me/sharing'); }
      catch (error) { if (error.status === 401 || error.status === 404) return; throw error; }
      if (!result.people.length) return;
      var box = node('section'); content.appendChild(box); box.appendChild(node('h2', 'Who can see your wishes'));
      result.people.forEach(function (person) {
        var row = node('div'); box.appendChild(row); paragraph(person.name, row);
        action('Stop sharing with ' + person.name, async function () {
          await api.request('/wishlist/me/sharing', { method: 'POST', body: { linkId: person.linkId } });
          row.textContent = 'Sharing stopped.';
          if (root.CustomEvent) root.document.dispatchEvent(new root.CustomEvent('fb-wishlist:recovered'));
          status.textContent = 'They can no longer see your list through this connection.';
        }, row);
      });
    }
    async function recipientPanel() {
      content.textContent = '';
      if (!token) {
        content.appendChild(node('h2', 'Keep or recover your wish list'));
        action('Recover with email', emailRecovery);
        proof(async function () { content.textContent = ''; paragraph('Your mobile is verified. Your saved list is ready below.'); link(copy('view_rewards_link', rewardVars), '/pages/wishlist-rewards?identity=list'); await sharingManagement(); });
        await sharingManagement();
        return;
      }
      if (!TOKEN.test(token)) { paragraph('This invitation link is invalid. Ask the person who invited you for a new link.'); return; }
      var invite;
      try { invite = await api.request(PREFIX + '/invitations/' + token); }
      catch (error) { if (error.status === 404) { paragraph('This invitation is no longer available. You can still make your own wish list below.'); return; } throw error; }
      if (!invite.valid) { paragraph('This invitation is no longer available.'); return; }
      try { await eventOnce('opened'); } catch (_) {}
      content.appendChild(node('h2', invite.inviterName ? invite.inviterName + ' would love to know what you like' : 'Share a little wish list inspiration'));
      paragraph('Choose your wishes below, verify your mobile, then accept the invitation to share your list.');
      if (invite.enabled) paragraph(copy('eligible_share', rewardVars));
      if (!invite.enabled) { paragraph(copy('rewards_paused', rewardVars)); }
      if (!invite.verified) proof(recipientPanel);
      else action('Accept invitation and share my list', async function () {
        var result = await post('/invitations/' + token + '/accept');
        status.textContent = result.message || 'Your invitation has been checked.';
      });
      link(copy('view_rewards_link', rewardVars), '/pages/wishlist-rewards?identity=list');
      await sharingManagement();
    }
    async function load() {
      content.textContent = '';
      content.className = '';
      if (recipient) { await recipientPanel(); return; }
      var state = await api.request(PREFIX);
      if (scope === 'list') {
        link('Back to your wish list', '/pages/wishlist');
        try { await wallet(); } catch (error) { if (error.status === 401) proof(load); else throw error; }
        return;
      }
      var offer = node('p', state.enabled ? copy('offer', rewardVars) : 'Gift-card rewards are paused. You can still invite friends and share wish lists. Existing gift cards remain available.');
      offer.className = 'fb-wishlist-rewards__offer'; content.appendChild(offer);
      var steps = node('ol'); steps.className = 'fb-wishlist-rewards__steps';
      ['Choose a friend', 'Send your invitation link', 'Discover what they’d love'].forEach(function (text) { steps.appendChild(node('li', text)); });
      content.appendChild(steps);
      ownerId = state.signedIn ? state.ownerId : null;
      if (!state.signedIn || !state.mobileVerified) { proof(load); return; }
      content.className = 'fb-wishlist-rewards__layout';
      await choosePerson();
      await wallet();
      link('Open your own wish list', '/pages/wishlist');
    }
    if (!recipient && (scope === 'member' || ['source', 'medium', 'campaign', 'content'].some(function (key) { return params.has('utm_' + key); }))) {
      var visitKey = 'visit_' + campaignKey;
      var visit = saved(visitKey) || saved(visitKey, { id: uuid(), sent: false });
      if (!visit.sent) post('/visits', { visitId: visit.id, campaign: attribution }).then(function () { saved(visitKey, { id: visit.id, sent: true }); }).catch(function () {});
    }
    load().catch(function (error) { status.textContent = errorText(error); action('Try again', load); });
  }
  return { start: start, campaign: campaign, invitationUrl: invitationUrl, errorText: errorText };
});
